import React from 'react';
import classes from './no-results-message.scss';
const getText = (phone, intercom, companyShowPhone) => {
  switch (true) {
    case companyShowPhone && phone && intercom:
      return `Please contact us through chat or call us at ${phone} and we would love to help.`;
    case companyShowPhone && phone && !intercom:
      return `Please call us at ${phone} and we would love to help.`;
    case intercom && !phone:
      return 'Please contact us through chat and we would love to help.';
    default:
      return '';
  }
};
export default function NoResultsMessage() {
  const {
    swag: {
      storeSettings: {
        companyPhone,
        intercomAppId,
        companyShowPhone
      }
    },
    intercomSettings
  } = window;
  const intercomEnabled = !!(intercomSettings && intercomAppId);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Sorry, we couldn't find anything.", ' ', getText(companyPhone, intercomEnabled, companyShowPhone)));
}